<script>
import format from 'date-fns/format'
import ptBR from 'date-fns/locale/pt-BR'

export default {
  components: {
  },
  props: {
    pagamentoLoteId: String,
    pagamentoGuias: Array,
    selectedPagamentoGuias: { type: Array, required: true },
    someGuiaConciliacaoAutomatica: Boolean,
    conciliacaoGuiasSelected: Array
  },
  data () {
    return {
      headers: [
      { value: 'guiaAssociada', text: '', align: 'end', show: true, disableSwitch: true },
      { value: 'quantidadeItensConciliados', text: 'Conc.', align: 'end', show: true },
      { value: 'numeroGuiaPrestador', text: 'Nº guia prestador', align: 'end', show: true  },
      { value: 'numeroGuiaOperadora', text: 'Nº guia operadora', align: 'end', show: true  },
      { value: 'beneficiario', text: 'Beneficiário', show: true  },
      { value: 'dataExecucao', text: 'Data execução', show: true  },
      { value: 'valorInformado', text: 'Valor informado', align: 'end', show: true  },
      { value: 'valorPago', text: 'Valor pago', align: 'end', show: true  },
      { value: 'valorGlosado', text: 'Valor glosado', align: 'end', show: true  },
      { value: 'senha', text: 'Senha', align: 'end', show: true },
      { value: 'quantidadeItens', text: 'Itens', align: 'end', show: true  },
      { value: 'quantidadeItensRecurso', text: 'Itens recurso', align: 'end', show: true  },
      { value: 'quantidadeItensEstorno', text: 'Itens estorno', align: 'end', show: true  },
      { value: 'id', text: 'Id', align: 'end', show: true  }
    ],
    sortingColumnsValues: [
      { text: 'Valor Informado', value: 'valorInformado' },
      { text: 'Valor Glosado', value: 'valorGlosado' },
      { text: 'Valor Pago', value: 'valorPago' },
      { text: 'Número Guia Prestadora', value: 'numeroGuiaPrestador' },
      { text: 'Número Guia Operadora', value: 'numeroGuiaOperadora' },
      { text: 'Senha', value: 'senha' },
      { text: 'Itens', value: 'quantidadeItens' },
      { text: 'Número carteira', value: 'numeroCarteira'},
      { text: 'Percentual Conciliado', value: 'porcentagemConciliacao' }
    ],
    sortingOrderValues: [
      { text: 'Crescente', value: 'asc' },
      { text: 'Decrescente', value: 'desc' }
    ],
    sortingQuery: [{ value: '', direction: 'asc' }],
    conciliacaoDefault: {
      text: 'Todos os itens',
      value: {
        conciliacaoItensCountEq: undefined,
        conciliacaoItensCountGt: undefined
      }
    },
    conciliacaoItensFilter: [
      {
        text: 'Todos os itens',
        value: {
          conciliacaoItensCountEq: undefined,
          conciliacaoItensCountGt: undefined
        }
      },
      {
        text: 'Itens não conciliados',
        value: {
          conciliacaoItensCountEq: 0,
          conciliacaoItensCountGt: undefined
        }
      },
      {
        text: 'Itens conciliados',
        value: {
          conciliacaoItensCountEq: undefined,
          conciliacaoItensCountGt: 0
        }
      }
    ],
    guiasFinalizadasDefault: {
      text: 'Guia pendente',
      value: {
        guiasFinalizadas: false,
        guiasPendentes: true
      }
    },
    guiasFinalizadasFilter: [
      {
        text: 'Guia pendente',
        value: {
          guiasFinalizadas: false,
          guiasPendentes: true
        }
      },
      {
        text: 'Guia finalizada',
        value: {
          guiasFinalizadas: true,
          guiasPendentes: false
        }
      },
      {
        text: 'Todas as guias',
        value: {
          guiasFinalizadas: false,
          guiasPendentes: false
         }
      }
    ],
    filterConciliacaoItem: false,
    filterGuiaFinalizada: false,
    inputFilters: {},
    count: 0,
    desassociarPagamentoGuiasDialogOpen: false,
    }
  },
  methods: {
    updateCount () {
      this.count = Object.values(this.inputFilters)
        .filter(value => Boolean(value))
        .length
    },
    handleClearFilter () {
      this.inputFilters = {}
      this.updateCount()
      this.filterConciliacaoItem = false
      this.conciliacaoDefault = {
        text: 'Todos os itens',
        value: {
          conciliacaoItensCountEq: undefined,
          conciliacaoItensCountGt: undefined
        }
      },
      this.filterGuiaFinalizada = false
      this.guiasFinalizadasDefault = {
        text: 'Guia pendente',
        value: {
          guiasFinalizadas: false,
          guiasPendentes: true
        }
      },
      this.$emit('pagamentoGuiaFilterChange', this.inputFilters)
    },
    debouncedFilterChange (key, value) {
      this.$emit('selectedPagamentoGuiasChange', [])

      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        this.inputFilters[key] = value
        this.updateCount()
        this.$emit('pagamentoGuiaFilterChange', this.inputFilters)
      }, 500)
    },
    handleConciliacaoItensChange (value) {
      this.$emit('selectedPagamentoGuiasChange', [])
      if (value !== null) {
        const filter = this.inputFilters
        this.inputFilters = {
          ...filter,
          ...value
        }

        if (!this.filterConciliacaoItem) {
          this.count++
        }

        this.filterConciliacaoItem = true
        this.$emit('pagamentoGuiaFilterChange', this.inputFilters)
      } else {
        const filter = this.inputFilters
        this.inputFilters = {
          ...filter,
          conciliacaoItensCountEq: undefined,
          conciliacaoItensCountGt: undefined
        }
        this.conciliacaoDefault = {
          text: 'Todos os itens',
          value: {
            conciliacaoItensCountEq: undefined,
            conciliacaoItensCountGt: undefined
          }
        }
        this.filterConciliacaoItem = false
        this.count--
        this.$emit('pagamentoGuiaFilterChange', this.inputFilters)
      }
    },
    handleGuiasFinalizadasChange (value) {
      this.$emit('selectedPagamentoGuiasChange', [])
      if (value !== null) {
        const filter = this.inputFilters
        this.inputFilters = {
          ...filter,
          ...value
        }

        if (!this.filterGuiaFinalizada) {
          this.count++
        }

        this.filterGuiaFinalizada = true
        this.$emit('pagamentoGuiaFilterChange', this.inputFilters)
      } else {
        const filter = this.inputFilters
        this.inputFilters = {
          ...filter,
          guiasFinalizadas: false,
          guiasPendentes: true
        }
        this.guiasFinalizadasDefault = {
          text: 'Guia pendente',
          value: {
            guiasFinalizadas: false,
            guiasPendentes: true
          }
        },
        this.filterGuiaFinalizada = false
        this.count--
        this.$emit('pagamentoGuiaFilterChange', this.inputFilters)
      }
    },
    cleanSort () {
      this.sortingQuery = [{ value: null, direction: 'asc' }]

      this.$emit('pagamentoGuiaOrderQueryChange', this.sortingQuery)
    },
    addNewSort () {
      this.sortingQuery.push({
        value: null,
        direction: 'asc'
      })
    },
    removeSort (index) {
      this.sortingQuery.splice(index, 1)

      this.$emit('pagamentoGuiaOrderQueryChange', this.sortingQuery)
    },
    updateSortValue (index, newValue) {
      this.sortingQuery[index].value = newValue

      this.$emit('pagamentoGuiaOrderQueryChange', this.sortingQuery)
    },
    updateSortDirection (index, newDirection) {
      this.sortingQuery[index].direction = newDirection

      this.$emit('pagamentoGuiaOrderQueryChange', this.sortingQuery)
    },
    listaFaturamentoGuiasAssociadasIds (pagamentoGuiaId) {
      return this.conciliacaoGuiasSelected
        ?.find(conciliacaoGuia => conciliacaoGuia.pagamentoGuiaId === pagamentoGuiaId)
        ?.faturamentoGuiasId || []
    },
    handleGuiaAssociadaChipClick (pagamentoGuiaId) {
      const faturamentoGuiasId = this.listaFaturamentoGuiasAssociadasIds(pagamentoGuiaId)

      const guiasAssociadas = {
        faturamentoGuiasId,
        pagamentoGuiasId: [pagamentoGuiaId]
      }

      this.$emit('guiaAssociadaChipClick', guiasAssociadas)
    },
    guiaAssociadaChip (pagamentoGuiaId) {
      const indexes = this.conciliacaoGuiasSelected
        ?.filter(conciliacaoGuia => conciliacaoGuia.pagamentoGuiaId === pagamentoGuiaId)
        .map(conciliacaoGuia => conciliacaoGuia.index + 1)

      return indexes?.join(', ') || ''
    },
    handleDesconciliarClick () {
      var pagamentoGuiaIds = this.$props.selectedPagamentoGuias.map(pagamentoGuia => pagamentoGuia.id)
      const pagamentoGuias = this.conciliacaoGuias.filter(conciliacaoGuia => pagamentoGuiaIds.includes(conciliacaoGuia.pagamentoGuiaId))

      if(pagamentoGuias.length === 0) {
        const paramModal = {
          type: "warning",
          title: "Desconciliar itens",
          message: "Não é possível desconciliar itens não conciliados",
          btConfirm: { name: "Ok", show: true }
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        var query = {
          pagamentoGuiaIds
        }
        this.$emit('clickDesconciliar', query)
      }
    },
    handleDesassociarClick () {
      this.$emit('clickDesassociar', this.conciliacaoGuias)
      this.desassociarPagamentoGuiasDialogOpen = false
    },
    handleConciliacaoAutomaticaClick () {
      var data = this.$props.selectedPagamentoGuias.map(pagamentoGuia => {
        return {
          pagamentoLoteId: this.pagamentoLoteId,
          pagamentoGuiaId: pagamentoGuia.id
        }
      })
      var query = {
        data
      }
      this.$emit('clickConciliacaoAutomatica', query)
    }
  },
  computed: {
    computedSelectedPagamentoGuias: {
      get () {
        return this.$props.selectedPagamentoGuias
      },
      set (value) {
        this.$emit('selectedPagamentoGuiasChange', value)
      }
    },
    showBadge () {
      return this.count > 0
    },
    showSortBadge () {
      return this.sortCount > 0
    },
    sortCount () {
      return this.sortingQuery
        .filter(sort => Boolean(sort.value))
        .length
    },
    hasPagamentoGuiasAssociadas () {
      return (this.conciliacaoGuiasSelected
        ?.filter(conciliacaoGuia => conciliacaoGuia.faturamentoGuiasId?.length !== 0) || []
        ).length > 0
    },
    conciliacaoGuias () {
      return this.conciliacaoGuiasSelected?.map(conciliacaoGuia =>
        conciliacaoGuia.faturamentoGuiasId.map(faturamentoGuiaId => {
          return {
            pagamentoGuiaId: conciliacaoGuia.pagamentoGuiaId,
            faturamentoGuiaId
          }
        })
      ) || []
    },
    numeroGuiaPrestadorList () {
      return [...new Set(this.pagamentoGuias.map(pagamentoGuia => pagamentoGuia.numeroGuiaPrestador).filter(numeroGuia => numeroGuia != null))]
    },
    numeroGuiaOperadoraList () {
      return [...new Set(this.pagamentoGuias.map(pagamentoGuia => pagamentoGuia.numeroGuiaOperadora).filter(numeroGuia => numeroGuia != null))]
    },
    numeroCarteiraList () {
      return [...new Set(this.pagamentoGuias.map(pagamentoGuia => pagamentoGuia.numeroCarteira).filter(numeroCarteira => numeroCarteira != null))]
    },
    quantidadeItensList () {
      return [...new Set(this.pagamentoGuias.map(pagamentoGuia => pagamentoGuia.quantidadeItens).filter(quantidadeItens => quantidadeItens != null))]
    }
  },
  filters: {
    formatPercent(value) {
      const formatter = new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 })
      return formatter.format(value)
    },
    formatDate (date) {
      if (date?.toString().match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)) {
        const match = date.toString().match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/)

        return `${match[3]}/${match[2]}/${match[1]}`
      }

      return date ? format(new Date(date), 'P', { locale: ptBR }) : '-'
    },
    pluralize (count) {
      if (count === 0) {
        return 'Nenhuma guia selecionada'
      } else if (count === 1) {
        return '1 guia selecionada'
      } else {
        return `${count} guias selecionadas`
      }
    }
  }
}
</script>

<template>
  <div class="datatable-container">
    <div class="d-flex align-center justify-space-around">
      <div style="width: 100%;">
        <h3 class="pl-4">Guias de pagamento</h3>
      </div>
      <div v-if="selectedPagamentoGuias.length > 0" class="primary--text" style="width: 100%;">{{ selectedPagamentoGuias.length | pluralize }} de {{ pagamentoGuias.length }}</div>
      <div class="d-flex align-center pr-4" style="column-gap: 16px;">
        <v-menu
          offset-y
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-badge
              :value="showBadge"
              :content="count"
              class="white--text"
              color="primary"
              offset-y="15px"
              offset-x="7px"
            >
              <v-btn v-bind="attrs" v-on="on" class="mt-1" color="primary" x-small outlined>
                <v-icon dense x-small left>fa-filter</v-icon>
                FILTRAR
              </v-btn>
            </v-badge>
          </template>
          <div class="d-flex flex-column px-6 pt-4" style="background-color: white; max-height: 36vh; overflow: auto;">
            <v-autocomplete
              class="py-2"
              :items="numeroGuiaPrestadorList"
              key="numeroGuiaPrestador"
              @input="value => debouncedFilterChange('numeroGuiaPrestador', value)"
              :value="inputFilters['numeroGuiaPrestador']"
              :item-text="item => item"
              item-value="numeroGuiaPrestador"
              :label="'Numero guia prestador'"
              outlined
              clearable
              dense
              hide-details
            />
            <v-autocomplete
              class="py-2"
              :items="numeroGuiaOperadoraList"
              key="numeroGuiaOperadora"
              @input="value => debouncedFilterChange('numeroGuiaOperadora', value)"
              :value="inputFilters['numeroGuiaOperadora']"
              :item-text="item => item"
              item-value="numeroGuiaOperadora"
              :label="'Numero guia operadora'"
              outlined
              clearable
              dense
              hide-details
            />
            <v-autocomplete
              class="py-2"
              :items="numeroCarteiraList"
              key="numeroCarteira"
              @input="value => debouncedFilterChange('numeroCarteira', value)"
              :value="inputFilters['numeroCarteira']"
              :item-text="item => item"
              item-value="numeroCarteira"
              :label="'Número carteira'"
              outlined
              clearable
              dense
              hide-details
            />
            <v-autocomplete
              class="py-2"
              :items="quantidadeItensList"
              key="quantidadeItens"
              @input="value => debouncedFilterChange('quantidadeItens', value)"
              :value="inputFilters['quantidadeItens']"
              :item-text="item => item"
              item-value="quantidadeItens"
              :label="'Quantidade itens'"
              outlined
              clearable
              dense
              hide-details
            />
            <v-select
              class="py-2"
              v-model="conciliacaoDefault"
              :items="conciliacaoItensFilter"
              @input="value => handleConciliacaoItensChange(value)"
              clearable
              :style="'width: 240px'"
              :label="'Itens'"
              outlined
              dense
              hide-details
            />
            <div style="display: flex; justify-content: end; background-color: #FFF; padding-bottom: 8px;"></div>
            <v-select
              v-model="guiasFinalizadasDefault"
              :items="guiasFinalizadasFilter"
              @input="value => handleGuiasFinalizadasChange(value)"
              clearable
              :style="'width: 240px'"
              :label="'Guias'"
              outlined
              dense
              hide-details
            />
            <div style="display: flex; justify-content: end; background-color: #FFF; padding-bottom: 8px;">
              <v-btn
                @click="handleClearFilter"
                color="primary"
                text
                x-small
              >
                Limpar
              </v-btn>
            </div>
          </div>
        </v-menu>
        <v-menu
          :close-on-content-click="false"
          offset-y
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-badge
              :value="showSortBadge"
              :content="sortCount"
              class="white--text"
              color="primary"
              offset-y="15px"
              offset-x="7px"
            >
              <v-btn v-bind="attrs" v-on="on" color="primary" class="mt-1" x-small outlined>
                <v-icon dense x-small left>fa-sort-amount-down</v-icon>
                Ordenar
              </v-btn>
            </v-badge>
          </template>
          <div style="background-color: #FFF;">
            <v-list>
              <v-list-item
                v-for="(sort, index) in sortingQuery"
                :key="index"
              >
                <div class="d-flex align-center">
                  <v-select
                    @change="event => updateSortValue(index, event)"
                    :items="sortingColumnsValues"
                    :value="sort.value"
                    :style="'width: 240px'"
                    class="mr-2"
                    outlined
                    dense
                    hide-details
                  />
                  <v-select
                    @change="event => updateSortDirection(index, event)"
                    :items="sortingOrderValues"
                    :value="sort.direction"
                    :style="'width: 152px'"
                    class="mr-2"
                    outlined
                    dense
                    hide-details
                  />
                    <v-btn
                      v-if="sortingQuery.length > 1"
                      @click="() => removeSort(index)"
                      icon
                    >
                    <v-icon color="primary">mdi-minus-circle</v-icon>
                  </v-btn>
                </div>
              </v-list-item>
            </v-list>
            <div>
              <v-btn
                @click="addNewSort"
                color="primary"
                class="ml-4 mr-1 mb-4"
                x-small
                rounded
              >
                Adicionar
              </v-btn>
              <v-btn
                @click="cleanSort"
                color="primary"
                outlined
                class="mb-4"
                x-small
                rounded
              >
                Limpar
              </v-btn>
            </div>
          </div>
        </v-menu>
        <v-menu offset-y>
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom :disabled="!someGuiaConciliacaoAutomatica">
              <template v-slot:activator="{ on: tooltip }">
                <div v-on="tooltip">
                  <v-btn
                    class="mt-1 mr-1"
                    color="primary"
                    x-small
                    outlined
                    v-bind="attrs"
                    v-on="menu"
                    :disabled="selectedPagamentoGuias.length === 0 || someGuiaConciliacaoAutomatica"
                  >
                    AÇÕES
                  </v-btn>
                </div>
              </template>
              <span>Uma das guias selecionadas apresenta status 'Conciliação Automática'</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item @click="() => desassociarPagamentoGuiasDialogOpen = true" :disabled="!hasPagamentoGuiasAssociadas">
              DESASSOCIAR
            </v-list-item>
            <v-list-item @click="handleConciliacaoAutomaticaClick">
              CONCILIAÇÃO AUTOMÁTICA
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      fixed-header
      :height="'calc(50vh - 90px)'"
      :items="pagamentoGuias"
      :loading-text="'Carregando...'"
      :footer-props="{
        'items-per-page-options': [10, 25, 50]
      }"
      item-key="id"
      class="text-no-wrap"
      dense
      disable-sort
      show-select
      v-model="computedSelectedPagamentoGuias"
      :disable-pagination="true"
      :hide-default-footer="true"
    >

      <template v-slot:item.guiaAssociada="{ item }" >
        <v-tooltip top v-if="guiaAssociadaChip(item.id)" :disabled="listaFaturamentoGuiasAssociadasIds(item.id).length !== 0">
          <template v-slot:activator="{ on: tooltip }">
            <div v-on="tooltip">
              <v-chip
                class="pa-1"
                x-small
                outlined
                @click="handleGuiaAssociadaChipClick(item.id)"
                :disabled="listaFaturamentoGuiasAssociadasIds(item.id).length === 0"
              >
                {{ guiaAssociadaChip(item.id) }}
              </v-chip>
            </div>
          </template>
          <span>
            Nenhuma guia de faturamento associada
          </span>
        </v-tooltip>
      </template>

      <template v-slot:item.quantidadeItensConciliados="{ item }">
        <div>
          {{ item.quantidadeItensConciliados / item.quantidadeItens | formatPercent }}
        </div>
      </template>

      <template v-slot:item.beneficiario="{ item }">
        <div class="d-flex flex-column">
          <div class="text-body-2">{{ item.nomeBeneficiario }}</div>
          <div class="caption">{{ item.numeroCarteira || '-' }}</div>
        </div>
      </template>

      <template v-slot:item.numeroGuiaPrestador="{ item }">
        {{ item.numeroGuiaPrestador || '-' }}
      </template>

      <template v-slot:item.dataExecucao="{ item }">
        {{ item.dataExecucao | formatDate }}
      </template>

      <template v-slot:item.numeroGuiaOperadora="{ item }">
        {{ item.numeroGuiaOperadora || '-' }}
      </template>

      <template v-slot:item.valorInformado="{ item }">
        R$ {{ item.valorInformado | formatPrice }}
      </template>

      <template v-slot:item.valorPago="{ item }">
        R$ {{ item.valorPago | formatPrice }}
      </template>

      <template v-slot:item.valorGlosado="{ item }">
        R$ {{ item.valorGlosado | formatPrice }}
      </template>
    </v-data-table>
    <v-dialog
      v-model="desassociarPagamentoGuiasDialogOpen"
      @click:outside="() => desassociarPagamentoGuiasDialogOpen = false"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          Desassociar guias de pagamento
        </v-card-title>
        <v-card-text>
          Esta ação vai desassociar as guias de pagamento selecionadas.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="handleDesassociarClick">Confirmar</v-btn>
          <v-btn @click="() => desassociarPagamentoGuiasDialogOpen = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.datatable-container {
  border: 1px solid rgb(204, 204, 204);
}
</style>
